export default [{
  path: '/modulos-aneel',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Atualização de Módulos ANEEL',
      path: 'historico',
      component: () => import('@/views/modulosAneel/Historico.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados'},
          { name: 'Atualização de Modulos ANEEL' }
        ]
      }
    },
    {
      name: 'Visualização de Modulo ANEEL',
      path: 'visualizar/:dataRef/:versao',
      component: () => import('@/views/modulosAneel/Visualizar.vue'),
      meta: {
        requiresAuth: true,
        admin: true,
        breadcrumb: [
          { name: 'Dados', path: '/dados' },
          { name: 'Atualização de Modulos ANEEL', path: '/modulos-aneel/historico' },
          { name: 'Visualizar'}
        ]
      }
    }
  ]
}]